import * as RasaInput from '../../components/rasa-input'
import * as Types from './types'

interface SubscriptionInterface {
  id: string,
  name: string,
}
type Subscriptions = SubscriptionInterface[]

export const getSubscriptionName = (id: string, subscriptions: Subscriptions) => {
  for (const key in subscriptions) {
    if (id === subscriptions[key].id) {
      return subscriptions[key].name
    }
  }
  return ''
}
export const getSubscriptionId = (name: string, subscriptions: Subscriptions) => {
  for (const key in subscriptions) {
    if (name === subscriptions[key].name) {
      return subscriptions[key].id
    }
  }
  return ''
}

export const configStateValid = (source: Types.SelectedSource): boolean =>
  !RasaInput.validateEvergreenDate(source.evergreen_date).invalid

export const asSubmitPayload = (source: Types.SelectedSource): Types.SubmitPayload => {
  return {
    blacklist_matches: source.blacklist_matches,
    category_type_id: source.category_type_id,
    evergreen_date: source.evergreen_date,
    filter_attribute: source.filter_attribute,
    filter_value: source.filter_value,
    is_active: source.is_active,
    is_gated: source.is_gated,
    minimum_quality_score: source.minimum_quality_score,
    minimum_tag_count: source.minimum_tag_count,
    name: source.name,
    newsbrief_count: source.newsbrief_count,
    subscription_type_id: Number(source.subscription_type_id),
    weight: source.weight,
    whitelist_matches: source.whitelist_matches,
  }
}



// WEBPACK FOOTER //
// ./src/pages/source-config/utils.ts